var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{hide: !_vm.show},style:(_vm.wrapperStyle),attrs:{"data-flex":"dir:top main:center cross:center"}},[_c('span',{staticClass:"spinner",attrs:{"data-flex-box":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }